import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { EMPTY, Observable, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { MacUserService } from '../../../../../services/user/mac-user.service';
import { ApiErrorResponse, ApiResponse, ApiServiceInterface, NavItem } from '@hutsix/ngxh6';
import { User_default_user_get_collection_user_get_item } from '../../../../../api_types';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class UserComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject<void>();
    private params: Params;

    public user$: Observable<ApiResponse<User_default_user_get_collection_user_get_item>>;
    public error: ApiErrorResponse<any>;

    public navItems: NavItem[] = [
        { id: 'edit', label: 'Edit', icon: 'fa-pencil', destroyOnHide: false },
        { id: 'attendance', label: 'Attendance', icon: 'fa-users', destroyOnHide: true, roles: ['ROLE_MACYOUTH'] },
        { id: 'notes', label: 'Notes', icon: 'fa-comments fa-regular', destroyOnHide: true },
        { id: 'history', label: 'History', icon: 'fa-clock-rotate-left', destroyOnHide: true, roles: ['ROLE_ADMIN'] },
    ];

    constructor(
        private route: ActivatedRoute,
        @Inject('ApiService') private api: ApiServiceInterface,
        @Inject('UserService') public userService: MacUserService,
        private cdRef: ChangeDetectorRef,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.route.params.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
            this.params = params;
            this.refreshData();
        });
    }

    refreshData(): void {
        this.user$ = this.api.get({ url: '/api/v1/users/' + this.params.id, displayErrors: false }).pipe(
            catchError(err => {
                this.error = err;
                this.cdRef.detectChanges();
                return EMPTY;
            }),
        );
    }

    returnToList(): void {
        this.router.navigate(['../'], { relativeTo: this.route });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
